/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardSortCriteria {
    getFixupPrototypeFunction() { return ComplianceStandardSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardSortCriteria>): ComplianceStandardSortCriteria {
        let obj = Object.assign(new ComplianceStandardSortCriteria(), model);
        ComplianceStandardSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardSortCriteria>): ComplianceStandardSortCriteria {
        if (!model) return null;
        return ComplianceStandardSortCriteria.newInstance(<ComplianceStandardSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardSortCriteria) {
        if (!obj) return;

        models.ComplianceStandardSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardSortCriteria): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ComplianceStandardSortColumn;

    ascending: boolean;

}
